import { format, parseISO } from 'date-fns';

const InvalidDate = 'Invalid Date';

export function formatDate(dateParam?: string, withTime = false): string {
  if (!dateParam) {
    return '';
  }
  const date = parseISO(dateParam);
  if (isNaN(date.getTime())) {
    return InvalidDate;
  }

  if (withTime) {
    return format(date, 'dd/MM/yyyy HH:mm');
  } else {
    return format(date, 'dd/MM/yyyy');
  }
}
